export class ErrorHandlerService {
    private _handlers: InternalErrorHandlerService[] = [];

    public handleForbiddenError(error: any): boolean {
        for (const handler of this._handlers) {
            if (handler.handleForbiddenError(error)) {
                return true;
            }
        }
        return false;
    }

    public handleQueryError(errorCode: string, queryParams: any): boolean {
        for (const handler of this._handlers) {
            if (handler.handleQueryError(errorCode, queryParams)) {
                return true;
            }
        }
        return false;
    }

    public registerHandler(handler: InternalErrorHandlerService): void {
        this._handlers.push(handler);
    }

    public unregisterHandler(handler: InternalErrorHandlerService): void {
        this._handlers = this._handlers.filter((h) => h !== handler);
    }
}

export abstract class InternalErrorHandlerService {
    public abstract handleForbiddenError(error: any): boolean;
    public abstract handleQueryError(errorCode: string, queryParams: any): boolean;
}
